import {
  ContractType,
  Country,
  LivingSpaceOption,
  LivingSpaceRange,
} from '@immosky/types';

interface LivingSpaceOptions {
  buy: LivingSpaceOption[];
  rent: LivingSpaceOption[];
}

export const INITIAL_LIVING_SPACE_RANGE: LivingSpaceRange = {
  min: {
    text: '',
    value: 0,
  },
  max: {
    text: '',
    value: 0,
  },
};

const countrySpecificLivingSpaceOptions: {
  [country: string]: LivingSpaceOptions;
} = {
  ['CH']: {
    buy: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '75',
        value: 75,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '125',
        value: 125,
      },
      {
        text: '150',
        value: 150,
      },
      {
        text: '175',
        value: 175,
      },
      {
        text: '200',
        value: 200,
      },
      {
        text: '225',
        value: 225,
      },
      {
        text: '250+',
        value: Infinity,
      },
    ],
    rent: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '75',
        value: 75,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '125',
        value: 125,
      },
      {
        text: '150',
        value: 150,
      },
      {
        text: '175',
        value: 175,
      },
      {
        text: '200+',
        value: Infinity,
      },
    ],
  },
  ['FR']: {
    buy: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '75',
        value: 75,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '125',
        value: 125,
      },
      {
        text: '150',
        value: 150,
      },
      {
        text: '175',
        value: 175,
      },
      {
        text: '200',
        value: 200,
      },
      {
        text: '225',
        value: 225,
      },
      {
        text: '250',
        value: 250,
      },
      {
        text: '275',
        value: 275,
      },
      {
        text: '300',
        value: 300,
      },
      {
        text: '300+',
        value: Infinity,
      },
    ],
    rent: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '75',
        value: 75,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '125',
        value: 125,
      },
      {
        text: '150',
        value: 150,
      },
      {
        text: '175',
        value: 175,
      },
      {
        text: '200',
        value: 200,
      },
      {
        text: '200+',
        value: Infinity,
      },
    ],
  },
};

export function getLivingSpaceOptionsForContractType(
  countries: Country[],
  contractType: ContractType
): LivingSpaceOption[] {
  let livingSpaceOptions = countrySpecificLivingSpaceOptions['CH'];

  if (countries.indexOf('FR') > -1) {
    livingSpaceOptions = countrySpecificLivingSpaceOptions['FR'];
  }

  switch (countries && contractType) {
    case 'buy':
      return livingSpaceOptions.buy;
    case 'rent':
      return livingSpaceOptions.rent;
  }
}
